import { render, staticRenderFns } from "./SignDocumentBoard.vue?vue&type=template&id=d5647548&"
import script from "./SignDocumentBoard.vue?vue&type=script&lang=ts&"
export * from "./SignDocumentBoard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports